export const SIGNATURE_GET_SIGNATURE_BYTES_START = 'SIGNATURE_GET_SIGNATURE_BYTES_START';
export const SIGNATURE_GET_SIGNATURE_BYTES_SUCCESS = 'SIGNATURE_GET_SIGNATURE_BYTES_SUCCESS';
export const SIGNATURE_GET_SIGNATURE_BYTES_FAIL = 'SIGNATURE_GET_SIGNATURE_BYTES_FAIL';

export const SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_START = 'SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_START';
export const SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_SUCCESS = 'SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_SUCCESS';
export const SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_FAIL = 'SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_FAIL';

export const SIGNATURE_GET_GENERATED_SIGNATURE_START = 'SIGNATURE_GET_GENERATED_SIGNATURE_START';
export const SIGNATURE_GET_GENERATED_SIGNATURE_SUCCESS = 'SIGNATURE_GET_GENERATED_SIGNATURE_SUCCESS';
export const SIGNATURE_GET_GENERATED_SIGNATURE_FAIL = 'SIGNATURE_GET_GENERATED_SIGNATURE_FAIL';

export const SIGNATURE_SAVE_SIGNATURE_START = 'SIGNATURE_SAVE_SIGNATURE_START';
export const SIGNATURE_SAVE_SIGNATURE_SUCCESS = 'SIGNATURE_SAVE_SIGNATURE_SUCCESS';
export const SIGNATURE_SAVE_SIGNATURE_FAIL = 'SIGNATURE_SAVE_SIGNATURE_FAIL';

export const SIGNATURE_GET_SIGNATURE_NAME_START = 'SIGNATURE_GET_SIGNATURE_NAME_START';
export const SIGNATURE_GET_SIGNATURE_NAME_SUCCESS = 'SIGNATURE_GET_SIGNATURE_NAME_SUCCESS';
export const SIGNATURE_GET_SIGNATURE_NAME_FAIL = 'SIGNATURE_GET_SIGNATURE_NAME_FAIL';

export const SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_START = 'SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_START';
export const SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_SUCCESS = 'SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_SUCCESS';
export const SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_FAIL = 'SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_FAIL';
